<template>
  <v-navigation-drawer :value="drawer" @input="toggleDrawer" app clipped>
    <v-list dense nav>
      <!-- <v-list-item link @click="() => goToRoute(Routes.CALCULO)">
        <v-list-item-action>
          <v-icon>mdi-math-compass</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Calculo</v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->
      <v-list-item link @click="goToRoute(Routes.DOCUMENTOS)">
        <v-list-item-action>
          <v-icon>mdi-ferry</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Documentos</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item link @click="goToRoute(Routes.TRACKING)">
        <v-list-item-action>
          <v-icon>mdi-ferry</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Tracking</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item link @click="goToRoute(Routes.POSICION)">
        <v-list-item-action>
          <v-icon>mdi-ferry</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Posiciones Arancelarias</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { Routes } from "../router";
export default {
  data: () => {
    return {
      Routes,
    };
  },
  computed: {
    ...mapState("auth", ["drawer"]),
    // navDocumentos: function () {
    //   return this.$router.history.current.name === 'Documentos'
    // }
  },
  methods: {
    ...mapMutations("auth", ["toggleDrawer"]),
    goToRoute(name) {
      // console.log('!', this.$router.history.current.name)
      // :disabled="$router.history.current.name === 'Documentos'"
      // :disabled="$router.history.current.name === 'Tracking'"
      // :disabled="$router.history.current.name === 'Posición'"
      this.$router.push({ name });
    },
  },
};
</script>